const { getCookie } = require('./browserData');
const { COOKIES } = require('../constants');

const getDefaultPoliticalId = require('../apis/getDefaultPoliticalId');

const getPoliticalId = (tenantId, catalystBaseUrl) => {
  let politicalId = getCookie(COOKIES.POLITICAL_ID);
  if (politicalId) {
    return politicalId;
  }

  politicalId = getDefaultPoliticalId(tenantId, catalystBaseUrl);
  return politicalId;
};

module.exports = getPoliticalId;
